export const VIDEO_CB_FIEN_URL = 'https://player.vimeo.com/video/581196000'
export const VIDEO_CB_EVA_URL = 'https://player.vimeo.com/video/581196385'
export const VIDEO_EDR_1_URL = 'https://player.vimeo.com/video/581195770'
export const VIDEO_EDR_2_URL = 'https://player.vimeo.com/video/581195826'
export const VIDEO_EDR_3_URL = 'https://player.vimeo.com/video/581195913'
export const VIDEO_BBP_URL = 'https://player.vimeo.com/video/581196269'
export const VIDEO_ICELAND_1_URL_NL = 'https://player.vimeo.com/video/387405120'
export const VIDEO_ICELAND_1_URL_FR = 'https://player.vimeo.com/video/651084202'
export const VIDEO_ICELAND_2_URL = 'https://player.vimeo.com/video/581196154'
export const VIDEO_FESTIVALS_URL = 'https://player.vimeo.com/video/585702768'

export const MOBILE_BREAK_POINT = 600
